import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';

import '@f0rce/lit-ace/lit-ace.js';
import {
  authenticatedAPICall,
  isSuccessfulAPIResponse,
} from '../../client/api-client';
import { converTemplateTypeToReadable } from '../../util/util';
import { repeat } from 'lit/directives/repeat.js';
import { Template } from '../../types/types';
import '../../elements/langhout-button/langhout-button';
import '../langhout-beton-update-template/langhout-beton-update-template';
import { sharedStyles } from '../../elements/shared-styles';

@customElement('langhout-beton-list-templates')
export class LanghoutBetonlistTemplates extends LitElement {
  static styles = [
    sharedStyles,
    css`
      .row {
        display: flex;
        flex-direction: row;
      }

      .row-flex {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        flex-flow: row wrap;
      }

      .product-column {
        text-align: left;
        width: 100%;
        min-width: 120px;
        min-height: calc(54px - 24px);
      }

      .order-id-click {
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: var(--primary-color);
      }

      .order-id-click:hover {
        cursor: pointer;
      }

      .border-bot {
        border-bottom: 2px solid var(--menu-color);
      }

      .column-large {
        text-align: left;
        min-width: calc(350px - 20px);
        max-width: calc(350px - 20px);
      }

      .table-wrapper {
        overflow-x: auto;
      }

      .table-header {
        color: var(--text-color-light);
      }

      .header-column {
        background-color: var(--menu-color);
        padding-left: 12px;
      }

      .column-border-right {
        border-right: 2px solid var(--menu-color);
      }

      langhout-beton-update-template {
        position: absolute;
        top: 84px;
        right: -200vw;
      }

      :host([backAnimation]) langhout-beton-update-template {
        transition-duration: 500ms;
      }

      :host([viewTemplate]) langhout-beton-update-template {
        transition-duration: 500ms;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: calc(100vw - 60px);
        height: calc(100vh -84px);
        top: 84px;
      }

      lit-ace {
        height: 400px;
        width: 500px;
      }
    `,
  ];

  private requestCounter = 0;

  private listTimer = 0;

  @property({ type: Array })
  private templates: Template[] = [];

  @property({ type: Boolean, reflect: true })
  public viewTemplate = false;

  @property({ type: Boolean, reflect: true })
  public backAnimation = false;

  @property({ type: Object })
  private currentTemplate: Template = <Template>{};

  constructor() {
    super();
    this.listTemplates();
  }

  render() {
    return html`
      <langhout-beton-update-template
        .currentTemplate=${this.currentTemplate}
        @close="${() => {
          this.viewTemplate = false;
          this.listTemplates();
        }}"
      ></langhout-beton-update-template>
      <div class="table-wrapper">
        <div class="row table-header">
          <div class="column header-column product-column">
            <div class="row">
              <h3>Naam</h3>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Type</h3>
            </div>
          </div>
        </div>
        ${this.renderRows()}
      </div>
    `;
  }

  renderRows = () => {
    return html` ${repeat(
      this.templates,
      template => template.id,
      (template, index) => {
        let tableColumnClass = 'border-bot';
        if (index == this.templates.length - 1) {
          tableColumnClass = '';
        }
        return html`
          <div
            class="row table-row"
            @click="${() => {
              this.viewTemplate = true;
              this.currentTemplate = template;
            }}"
          >
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${template.name}
            </div>
            <div class="column table-column product-column ${tableColumnClass}">
              ${converTemplateTypeToReadable(template.type)}
            </div>
          </div>
        `;
      },
    )}`;
  };

  listWithBackoff = () => {
    clearInterval(this.listTimer);
    this.listTimer = window.setTimeout(() => {
      this.listTemplates();
    }, 50);
  };

  listTemplates = async () => {
    this.requestCounter++;
    const requestCounter = this.requestCounter;

    const path = `/templates`;

    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (requestCounter != this.requestCounter) {
      return;
    }
    if (isSuccessfulAPIResponse(result)) {
      this.templates = result.body;
    }
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-list-templates': LanghoutBetonlistTemplates;
  }
}
